module.exports = __webpack_public_path__ + "img/6.47789d67.jpeg";